<div class="tab" [class.active]="isActive()" *ngIf="isActive()">
  <ng-content></ng-content>
</div>
